import { EsignResultDetail } from "@/pages/esign/widgets/EsignResultDetail.tsx";
import { EsignSignatureCertificateModal } from "@/pages/esign/widgets/EsignSignatureCertificateModal.tsx";
import { ApiEsignResult, EsignSignatureType } from "@/types/esign.types.ts";
import { Modal, ModalProps, Stack, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface EmployeeDocumentEsignModalProps extends ModalProps {
  esignResult: ApiEsignResult;
  documentId: number;
  documentTitle: string;
}

export function EmployeeDocumentEsignModal({
  esignResult,
  documentId,
  documentTitle,
  ...props
}: EmployeeDocumentEsignModalProps) {
  const { t } = useTranslation();
  const { openModal, close } = useModals();

  const isSignature = esignResult.signature_type === EsignSignatureType.signature;
  const typeLabel = isSignature
    ? t("core:esign_signing")
    : t("workflow:action_type_esign_acknowledgment");

  const handleShowCertificate = (envelopeId: string, requestPublicId: string) => {
    openModal(EsignSignatureCertificateModal, { envelopeId, requestPublicId });
    close(props.id);
  };

  return (
    <Modal
      {...props}
      title={t("common:request")}
      caption={`${typeLabel} · ${documentTitle}`}
      variant="middle"
      layout="stretch"
      size="md"
      withCloser
    >
      <Stack gap="lg">
        <EsignResultDetail
          esignResult={esignResult}
          documentId={documentId}
          documentTitle={documentTitle}
          onShowCertificate={handleShowCertificate}
        />
      </Stack>
    </Modal>
  );
}
